module.exports = __webpack_public_path__ + "img/ts_iconn.fab3c851.svg";